module.exports = (__webpack_require__(15))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/classCallCheck.js from dll-reference vendor_library
// module id = 30
// module chunks = 0